<template>
  <div class='AccountIn'>
    <topNav :title="$t('AccountIn_title')"></topNav>
    <div class="acon">
      <div class="form">
        <div class="info">
          <label>{{$t('AccountIn_rmno')}}</label>
          <span class="inv">{{rmno}}</span>
        </div>
        <div class="info">
          <label>{{$t('AccountIn_name')}}</label>
          <span class="inv">{{name}}</span>
        </div>
        <div class="info">
          <label>{{$t('AccountIn_taCode')}} <i class="must">*</i></label>
          <span @click="getTaCode"
                class="inv select">{{feeInfo.taCode}}<span v-show="feeInfo.taCode"> -- </span>{{accountName}}
            <i class="iconfont icon-xia"></i>
          </span>
        </div>


        <div class="info"
             v-if='isRCV'>
          <!-- 会员卡 -->
          <label>{{$t('AccountIn_clubCard')}} <i class="must">*</i></label>
          <popSearch type="mem"
                     class='inv select is-popup'
                     anchor='cardNo'
                     :searchNow="false"
                     @onSelect='onSelectCard'></popSearch>
        </div>

        <div class="info"
             v-if='isAR'>
          <!-- 挂AR账 -->
          <label>{{$t('incomeAccount_msg_ar_select_company')}} <i class="must">*</i></label>
          <popSearchArPayGroup class='inv select is-popup'
                               anchor='name'
                               :searchNow="false"
                               @onSelect='onSelectArPayGroup'></popSearchArPayGroup>
        </div>

        <div class="info"
             v-if='isRCV'>
          <label>{{$t('incomeAccount_select_subAccount_title')}} <i class="must">*</i></label>
          <div class="inv select is-popup">
            <gpicker ref="subAccount"
                     :placeholder="$t('incomeAccount_select_subAccount_pl')"></gpicker>
          </div>
        </div>

        <div class="info">
          <label>{{$t('AccountIn_money')}} <i class="must">*</i></label>
          <span class="inv"
                v-if='isCheckout'>{{feeInfo.money}}</span>
          <input type="number"
                 v-else
                 v-model="feeInfo.money"
                 :placeholder="$t('AccountIn_money_placeholder')">
        </div>

        <div v-if='isCheckout'>
          <div class="info">
            <!-- 结账提醒 -->
            <label>{{$t('fangTXQ_coMsg')}} :</label>
            <span style="color:red">{{coMsg}}</span>
          </div>

          <div class="btns-wrap"
               v-if='showPayBtn'>
            <div class="staRBtn">
              <div class="btn"
                   @click="goScanPay">{{$t('scanPay_title')}}
              </div>
            </div>

            <div class="staRBtn">
              <div class="btn"
                   @click="surePay">{{$t('AccountIn_save')}}
              </div>
            </div>
          </div>

          <div class="btns-wrap"
               v-else>
            <div class="staRBtn fullWidth">
              <div class="btn"
                   @click="surePay">{{$t('AccountIn_save')}}
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="info">
            <label>{{$t('AccountIn_taNo')}}</label>
            <input type="text"
                   v-model="feeInfo.taNo"
                   :placeholder="$t('memberRegister_cardSrc_placeholder')">
          </div>
          <div class="info">
            <label>{{$t('AccountIn_taRemark')}}</label>
            <textarea rows="3"
                      v-model="feeInfo.taRemark"></textarea>
          </div>

          <div class="info">
            <div class="staRBtn">
              <div class="btn"
                   @click="save">{{$t('AccountIn_save')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mt-popup v-model="disTaCode"
              position="right"
              class="AccountCode"
              :modal="false">
      <ACode ref="selectAccount"
             @cancel="disTaCode=false"
             @select="selectAccount"></ACode>
    </mt-popup>

    <actionsheet :actions="actions"
                 v-model="sheetVisible"
                 :cancelText="$t('cancel')"></actionsheet>

    <mt-popup v-model="showAddModal"
              class='selectShift select-wrap'
              popup-transition="popup-fade">
      <!--班别选择-->
      <h2>{{$t('MessageBox_checkOutAdd')}}</h2>
      <div class='select-list-wrap'>
        <mt-radio
          v-model="currentCode"
          :options="shiftArr">
        </mt-radio>
      </div>
      <div class="btn">
        <div class="unSure"
             @click="showAddModal=false">{{$t('cancel')}}
        </div>
        <div class="sure"
             @click="addReceiveP">{{$t('determine')}}
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
  import _ from "lodash";
  import gpicker from "../../common/gpicker";
  import ACode from "./IncomeAccount-comp/AccountCode";
  import {
    MessageBox,
    Actionsheet
  } from "mint-ui";
  import popSearch from "../../common/popSearch";
  import popSearchArPayGroup from "./IncomeAccount-comp/popSearchArPayGroup";

  export default {
    data() {
      return {
        feeInfo: {
          crsNo: "",
          masterId: null,
          money: null,
          taCode: null,
          taRemark: null,
          taNo: "",
          tag: null,
        },
        disTaCode: false,
        accountName: null,
        rmno: null,
        name: null,

        showPayBtn: false,

        isRCV: false, // 结账类型是否为会员卡
        cardNo: '', // 会员卡号
        subAccountList: [], // 分账户列表

        isAR: false,
        TransAccnt: "", // 公司ID
        TransSubaccnt: "",

        isCheckout: false, // 结账的逻辑
        actions: [],
        sheetVisible: false,
        coMsg: '',

        currentShift: {},

        showAddModal: false,
        currentCode: '',
        shiftArr: [{
          label: this.$t("MessageBox_checkOutAdd_action0"),
          value: '0'
        },{
          label: this.$t("MessageBox_checkOutAdd_action1"),
          value: '1'
        }],
        isPreAuth: false
      };
    },
    props: {},
    mounted() {
      let query = this.$route.query || {}
      this.feeInfo.masterId = query.id;
      this.rmno = query.rmno;
      this.name = query.name;
      this.isCheckout = query.isCheckout == 'yes'
      this.coMsg = query.coMsg || ''
      this.showPayBtn = query.showPayBtn == 'yes'

      this.getLocalShift()

      if (this.isCheckout) {
        this.getCheckoutInfo(true)
      }
    },
    methods: {
      getLocalShift() {
        let localShift = localStorage.getItem('currentShift') || '';
        this.currentShift = localShift ? JSON.parse(localShift) : {}
      },
      onSelectCard(item) {
        this.cardNo = item.cardNo || ''
      },

      onSelectArPayGroup(item) {
        this.TransAccnt = item.arCompanyId || ''
        this.TransSubaccnt = item.arAccountId || ''
      },

      goScanPay() {
        this.$router.push("/ftxq/scanPay" + this.formatUrlParam());
      },

      formatUrlParam() {
        var m = this.feeInfo || {};
        return '?id=' + m.masterId +
          "&rmno=" +
          this.rmno +
          "&name=" +
          this.name +
          "&money=" +
          m.money +
          "&redirect=" +
          encodeURIComponent("/fangTXQ?id=" + m.masterId)
      },

      getCheckoutInfo(check) {
        this.$http.post(
          "/mobilepmsapi/reception/getCheckoutInfo/" + this.feeInfo.masterId
        ).then(res => {
          if (res.data.result == 0) {
            let retVal = res.data.retVal || {}
            this.name = retVal.name
            this.feeInfo.money = retVal.needMoney
            if (check && retVal.addChangeType >= 0) {
              if (retVal.addChangeType == 0){
                this.currentCode = '0'
              }
              if (retVal.addChangeType == 1){
                this.currentCode = '1'
              }
              this.showAddModal = true
            }
          }
        });
      },

      addReceiveP() {
        let currentCode = this.currentCode
        let notice = ''
        if (currentCode === ''){
          this.msg2(this.$t('MessageBox_checkOutAdd_select'));
        } else {
          let type = ''
          if (currentCode == '0'){
            type = 0
            notice = this.$t('MessageBox_checkOutAdd_action0_sure')
          } else {
            type = 1
            notice = this.$t('MessageBox_checkOutAdd_action1_sure')
          }
          this.confirm2(notice, action => {
            this.$http
              .post("/mobilepmsapi/reception/roomAddCharge", {
                id: this.feeInfo.masterId,
                type: type,
                cashier: Number(this.currentShift.code)
              }).then(res => {
              if (res.data.result == 0) {
                this.msg2(this.$t("msg_addReceive_success"));
                this.showAddModal = false
                this.getCheckoutInfo(false);
              } else {
                this.msg2(res.data.msg);
              }
            })
          })
        }
      },

      /*退房确认*/
      surePay() {
        let feeInfo = this.feeInfo || {}
        if (!feeInfo.taCode) {
          this.msg2(this.$t("msg_isEmpty_taCode"));
          return;
        }

        if (this.isAR) {
          this.doArAccountIn()
        } else {
          // 如果是会员卡的话，多一层判断
          if (this.isRCV) {
            if (this.$refs.subAccount.getValue() === '') {
              this.msg2(this.$t('incomeAccount_msg_select_subAccount'));
              return;
            }
            if (!this.cardNo) {
              this.msg2(this.$t("msg_isEmpty_cardNo"));
              return;
            }
          }
          let param = {
            id: Number(feeInfo.masterId),
            ta: feeInfo.taCode,
            pay: feeInfo.money,
            cashier: Number(this.currentShift.code)
          }
          if (this.isRCV) {
            param.cardNo = this.cardNo
            param.subaccntId = this.$refs.subAccount.getValue()
          }
          this.$http.post("/mobilepmsapi/reception/checkout", param).then(res => {
            if (res.data.result == 0) {
              this.msg2(this.$t("msg_paySuccess"));
              this.cancel();
            } else {
              this.msg2(res.data.msg);
            }
          });
        }
      },

      doArAccountIn() {
        if (!this.TransAccnt) {
          this.msg2(this.$t('incomeAccount_msg_ar_company'));
          return;
        }
        let feeInfo = this.feeInfo || {}
        let param = {
          accnt: feeInfo.masterId,
          taCode: feeInfo.taCode,
          TransAccnt: this.TransAccnt, // 公司ID
          TransSubaccnt: this.TransSubaccnt, // 个人ID
          cashier: Number(this.currentShift.code),
        }
        this.confirm2(
          this.$t("MessageBox_AccountIn_save") + this.feeInfo.money + "?", action => {
            this.$http.post("/mobilepmsapi/accounting/arPay", param)
              .then(res => {
                this.incomeSuccess(res)
              });
          })
      },

      getTaCode() {
        this.disTaCode = true;
        this.$refs.selectAccount.show(this.isCheckout);
      },

      getSubAccountList() {
        const self = this
        this.$http.post("/mobilepmsapi/accounting/subaccntIdReturn", {
          masterId: this.feeInfo.masterId
        }).then(res => {
          if (res.data.result == 0) {
            let retVal = res.data.retVal || {}
            this.subAccountList = retVal.subAccount || []
            let defaultCode = null
            if (this.subAccountList && this.subAccountList.length > 0) {
              let firstItem = this.subAccountList[0] || {}
              defaultCode = firstItem.code || null
            }
            self.$refs.subAccount.setData(retVal.subAccount, defaultCode, this.disCodeName);
          }
        });
      },

      disCodeName(v) {
        return v.code + " -- " + v.name;
      },

      selectAccount(item) {
        // 如果是会员卡类型的话，需要让用户选择会员卡
        // 锦江预授权不特殊处理会员卡，具体问杨超
        this.isRCV = item.catPosting === 'RCV' && !item.isPreAuth
        if (this.isRCV) {
          this.getSubAccountList()
        }

        // 如果是挂AR账类型，清空之前选择的
        this.isAR = item.catPosting === 'TA'
        this.TransAccnt = ''
        this.TransSubaccnt = ''

        this.feeInfo.taCode = item.code;
        this.accountName = item.descript;
        this.isPreAuth = item.isPreAuth || false;
        this.disTaCode = false;
      },

      cancel() {
        this.$router.push(this.$route.query.redirect || '/fantT');
      },

      save() {
        if (!this.feeInfo.taCode) {
          this.msg2(this.$t("msg_isEmpty_taCode"));
          return;
        }
        if (!this.feeInfo.money) {
          this.msg2(this.$t("msg_isEmpty_money"));
          return;
        }
        if (this.feeInfo.money <= 0 || isNaN(parseFloat(this.feeInfo.money))) {
          this.msg2(this.$t("msg_isEmpty_money2"));
          return;
        }
        if (this.isRCV) {
          // 会员卡扣款入账
          this.doClubCardAccountIn()
        } else {
          // 普通入账
          this.confirmAccountInSave()
        }
      },

      confirmAccountInSave() {
        this.confirm2(
          this.$t("MessageBox_AccountIn_save") + this.feeInfo.money + "?", action => {
            let param = this.feeInfo
            param.isPreAuth = this.isPreAuth // 预授权
            param.cashier = Number(this.currentShift.code)
            this.$http
              .post("/mobilepmsapi/reception/roomAddAccount", param)
              .then(res => {
                this.incomeSuccess(res)
              });
          })
      },

      doClubCardAccountIn() {
        console.log(this.$refs.subAccount.getValue())
        if (this.$refs.subAccount.getValue() === '') {
          this.msg2(this.$t('incomeAccount_msg_select_subAccount'));
          return;
        }
        if (!this.cardNo) {
          this.msg2(this.$t("msg_isEmpty_cardNo"));
          return;
        }
        let feeInfo = this.feeInfo || {}
        let param = {
          masterId: feeInfo.masterId,
          taCode: feeInfo.taCode,
          charge: feeInfo.money,
          cardNo: this.cardNo,
          subaccntId: this.$refs.subAccount.getValue(),
          cashier: Number(this.currentShift.code)
        }
        this.confirm2(
          this.$t("MessageBox_AccountIn_save") + feeInfo.money + "?", action => {
            this.$http.post("/mobilepmsapi/accounting/accountExt", param)
              .then(res => {
                this.incomeSuccess(res)
              });
          })
      },

      incomeSuccess(res) {
        if (res.data.result == 0) {
          this.msg2(this.$t('incomeAccount_success')); // 入账成功
          this.cancel();
        } else {
          this.msg2(res.data.msg);
        }
      }
    },

    components: {
      ACode,
      actionsheet: Actionsheet,
      gpicker,
      popSearch,
      popSearchArPayGroup
    }
  };
</script>
<style lang='less'>
  .AccountIn {
    .acon {
      .form {
        margin: 0.16rem 0 0 0;
        padding: 20px 0;
        background: #fff;
        width: 100%;

        .info {
          box-sizing: border-box;
          margin: 0.3rem auto;
          overflow: hidden;
          line-height: 0.88rem;

          label {
            box-sizing: border-box;
            padding-left: 0.5067rem;
            float: left;
            text-align: left;
            width: 2.5rem;
            font-size: 0.32rem;
          }

          input {
            float: left;
            width: 6.86666667rem;
            height: 0.88rem;
            border: 1px solid #e8e8e8;
            box-sizing: border-box;
            -webkit-appearance: none;
            padding-left: 0.2667rem;
            outline: 0;
          }

          .inv {
            float: left;
            width: 6.59996667rem;
            height: 0.88rem;
            border-radius: 4px;
            border: 1px solid #e8e8e8;
            padding-left: 0.2667rem;
            background: #f0f0f0;
            position: static;

            &.is-popup {
              .parent {
                border: 0;
                background: none;
                margin: 0;
              }

              .gpicker {
                height: 0.88rem;
                line-height: 0.88rem;
              }
            }

            &.select {
              background: #fff;
            }

            .icon-xia {
              position: absolute;
              right: 0.7rem;
            }
          }

          textarea {
            width: 6.86666667rem;
            line-height: 0.64rem;
            border: 1px solid #e8e8e8;
            -webkit-appearance: none;
            padding: 0.1rem 0.2667rem;
            box-sizing: border-box;
          }
        }

        .staRBtn {
          height: 1.2rem;
          background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);
          margin: 0 auto;
          width: 80%;
          border-radius: 10px;
          margin-top: 2rem;

          .btn {
            float: left;
            width: 100%;
            text-align: center;
            color: #fff;
            height: 0.4rem;
            font-size: 0.4rem;
            line-height: 0.4rem;

            margin-top: 0.4rem;
            box-sizing: border-box;
            border-right: 1px solid rgba(255, 255, 255, 0.5);
          }
        }
      }
    }

    .btns-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 0.5rem;

      .staRBtn {
        height: 1.2rem;
        background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);
        border-radius: 10px;
        margin: 0 0.2rem !important;

        &.fullWidth {
          width: 100%;
        }

        .btn {
          width: 100%;
          text-align: center;
          color: #fff;
          height: 0.4rem;
          font-size: 0.4rem;
          line-height: 0.4rem;
          margin-top: 0.4rem;
          box-sizing: border-box;
          border-right: 1px solid rgba(255, 255, 255, 0.5);
        }
      }
    }

    .AccountCode {
      width: 100%;
      height: 100%;
      background: #fff;
      overflow-y: auto;
      overflow-x: hidden;
      position: fixed;
      bottom: 0;
    }

    .must {
      color: red;
    }

    .select-wrap {
      width: 80%;
      position: fixed;
      margin: 0 auto;
      background-color: #fff;
      border-radius: 10px;
      overflow: hidden;
      border: 1px solid #eee;

      .select-list-wrap {
        min-height: 150px;
        max-height: 280px;
        overflow-y: scroll;
      }

      h2 {
        font-size: 18px;
        color: #666666;
        text-align: center;
        font-style: normal;
        padding: 15px 0;
      }

      .mint-cell-title {
        width: 80px;
      }

      .btn {
        height: 55px;
        border-top: 1px solid #bdbdbd;
        text-align: center;
        font-size: 16px;
        width: 100%;

        .unSure {
          border-right: 1px solid #bdbdbd;
          width: 50%;
          box-sizing: border-box;
          float: left;
          line-height: 55px;
        }

        .sure {
          width: 50%;
          box-sizing: border-box;
          float: left;
          line-height: 55px;
          color: #5190c3;
        }

        .unSure,
        .sure {
          &:active {
            background: #eaeaea;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// IncomeAccount.vue?a52578c0